<template>
  <div>
    <p class="mb-2">
      Заезды <player-link :playerId="playerId">игрока {{playerId}}</player-link>
      в скачках {{derbyId}}.
    </p>

    <table v-if="isRacesVisible" class="table table-bordered text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col" rowspan="2">Заезд</th>
          <th scope="col" colspan="5" class="text-center">Игрок</th>
        </tr>
        <tr>
          <th scope="col">состояние</th>
          <th scope="col">присоединение</th>
          <th scope="col">начальный уровень</th>
          <th scope="col">очки</th>
          <th scope="col">обновление</th>
        </tr>
      </thead>
      <tr
        v-for="race in races"
        :key="race.race_id"
      >
        <td>
          <derby-race-link :raceId="race.race_id" />
        </td>
        <td>
          {{ race.state | participantStatusStr }}
        </td>
        <td>
          {{ race.joined_at | getMomentStr }}
        </td>
        <td class="text-right">
          {{ race.start_level | getFormattedNumber }}
        </td>
        <td class="text-right">
          {{ race.score | getFormattedNumber }}
        </td>
        <td>
          {{ race.updated_at | getMomentStr }}
        </td>
      </tr>
    </table>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../../http-common.js';
import notifier from '../../notifier.js';

import PlayerLink from '../PlayerLink.vue';
import LoadingIndicator from '../LoadingIndicator.vue';

import { Participant } from '../../model/race.js';

import DerbyRaceLink from './DerbyRaceLink.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'DerbyPlayerRaces',

  components: {
    PlayerLink,
    LoadingIndicator,
    DerbyRaceLink,
  },

  props: {
    derbyPlayerId: {
      type: Object,
      required: true
    }
  },

  computed: {
    /** @returns {number} */
    playerId() {
      return this.derbyPlayerId.playerId;
    },

    /** @returns {number} */
    derbyId() {
      return this.derbyPlayerId.derbyId;
    },

    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {boolean} */
    isRacesVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const races = this.races;
      if(races === null) {
        return false;
      }

      return races.length > 0;
    },
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {?Array} */
      races: null,
    };
  },

  created() {
    this.loadRaces();
  },

  methods: {
    loadRaces() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const derbyId = this.derbyId;
      const playerId = this.playerId;
      const url = `/derby/${derbyId}/player/${playerId}/races`;

      HTTP.get(url)
      .then(response => {
        this.races = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },

  filters: {
    participantStatusStr: status => Participant.getStatusName(status),
  },
};
</script>
